













import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import eventlogsRepository from '@/modules/shared/eventlogs/eventlogsRepository';

import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';
import EventLog from './EventLog.vue';

@Component({
    components: {
        EventLog,
    },
})
export default class EventLogsTable extends Vue {
    @Prop({required: true})
    public config!: IEventLogQuery;

    private pagedConfig: IEventLogQuery = {};

    private loading: boolean = true;
    private canLoadMore: boolean = true;

    private items: IEventLog[] = [];

    private mounted() {
        Object.assign(this.pagedConfig, this.config);
        this.pagedConfig.pageSize = 10;
        this.loadData();
    }

    private async loadData() {
        try {
            this.loading = true;

            if (this.pagedConfig.pageIndex === undefined) {
                this.pagedConfig.pageIndex = 0;
            }
            const result = (await eventlogsRepository.lookup(this.pagedConfig));

            if (result.data.length < 10) {
                this.canLoadMore = false;
            }

            result.data.forEach((item: IEventLog) => {
                this.items.push(item);
            });
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.loading = false;
        }
    }

    private async loadMore() {
        if (this.pagedConfig.pageIndex === undefined) {
            this.pagedConfig.pageIndex = 0;
        }

        this.pagedConfig.pageIndex++;
        this.loadData();
    }

    @Watch('config', {deep: true})
    private onConfigChange(value: IEventLogQuery) {
        Object.assign(this.pagedConfig, this.config);
        this.pagedConfig.pageSize = 10;
    }
}
